import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { qrSelector } from '../../redux/slices/qr'
import { getCurrentRoute, selectSelector } from '../../redux/slices/select'

export const useCurrentRoute = (route_id) => {
  const { routes } = useSelector(selectSelector)
  if (!route_id) return {}
  const route = getCurrentRoute(route_id, routes)

  return route
}

export const useSetCurrentRoute = (route_id, setter) => {
  const { routes } = useSelector(selectSelector)
  const { currentRoute } = useSelector(qrSelector)

  const dispatch = useDispatch()
  useEffect(() => {
    const route = getCurrentRoute(route_id, routes)
    dispatch(setter(route))
  }, [dispatch, routes, route_id, setter])

  return currentRoute
}
